export default class GuideVideoController {
    constructor() {
        const section = document.getElementById("huong-dan");

        if (!section) {
            return;
        }

        import(
            /* webpackChunkName: "GuideVideo" */ "../classes/style/GuideVideo"
        ).then((res) => {
            const GuideVideo = res.default;
            this.createInstance(GuideVideo, section);
        });
    }

    createInstance(GuideVideo, section) {
        return new GuideVideo(section);
    }
}
